import { createStore, combineReducers, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { loginReducer, stageReducer, uniInfoReducer } from './reducers'

const middlewares = [thunk]

const reducers = combineReducers({
    loginReducer: loginReducer,
    stageReducer: stageReducer,
    uniInfoReducer: uniInfoReducer,
})

export const Store = createStore(reducers, applyMiddleware(...middlewares))
